
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseText', component.exports)
}
export default {
	props: {
		as: {
			type: String,
			default: 'p'
		}
	},
	render: function(createElement) {
		return createElement(
			this.as, // tag name
			{
				class: 'text'
			},
			this.$slots.default // array of children
		);
	}
};
